
export default {
  mounted(el, binding) {
    console.log(binding.value);
  }
}
